// Plurals, choices and lists for message functions, in the active locale.
//
//   failed: (n: number) => plural(n, { one: "# change didn't save", other: "# changes didn't save" })
//   // fr: plural(n, { one: "# modification non enregistrée", other: "# modifications non enregistrées" })
//
// `#` is the count, formatted for the locale (1 234 in French).

import { getIntlLocale } from './runtime'

type PluralForms = Partial<Record<Intl.LDMLPluralRule, string>> & { other: string } & { [exact: `=${number}`]: string }

const rulesCache = new Map<string, Intl.PluralRules>()
const rules = (tag: string, type: Intl.PluralRuleType) => {
  const key = `${tag}:${type}`
  let r = rulesCache.get(key)
  if (!r) rulesCache.set(key, (r = new Intl.PluralRules(tag, { type })))
  return r
}

export function plural(n: number, forms: PluralForms, opts: { ordinal?: boolean } = {}): string {
  const tag = getIntlLocale()
  // An exact 0 / 1 form wins where a language wants one ("No games").
  const exact = forms[`=${n}`] as string | undefined
  const form = exact ?? forms[rules(tag, opts.ordinal ? 'ordinal' : 'cardinal').select(n)] ?? forms.other
  return form.replace(/#/g, new Intl.NumberFormat(tag).format(n))
}

/** A message that varies by a key (sport, role, gender of a noun): `select(sport, { soccer: '…', other: '…' })`. */
export function select<K extends string>(value: K | null | undefined, forms: Partial<Record<K, string>> & { other: string }): string {
  return (value != null ? forms[value] : undefined) ?? forms.other
}

/** "A, B and C" in the active locale. */
export function list(items: string[], type: 'conjunction' | 'disjunction' = 'conjunction'): string {
  return new Intl.ListFormat(getIntlLocale(), { style: 'long', type }).format(items)
}
